import { Controller } from '@hotwired/stimulus';
import { getMeta } from '../helpers';
import { forEach } from '@splidejs/splide/src/js/utils';

export default class extends Controller {
    connect() {
        this.cartID = this.element.dataset.cart;
        this.debounceTimer;
        this.currentLanguageCode = getMeta('wp-language').split('-')[0];
        this.loading = false;
    }

    async modifyCart(e) {
        const parent = e.currentTarget.parentNode;
        const productId = parent?.dataset.product;
        const quantityEl = parent?.querySelector('.product-quantity');
        const operation = e.currentTarget.dataset.operation;

        if (quantityEl?.innerHTML <= '0' && operation === 'decrease') {
            return;
        }

        if (operation === 'increase') {
            quantityEl.innerHTML = parseInt(quantityEl?.innerHTML) + 1;
        } else if (operation === 'decrease') {
            quantityEl.innerHTML = parseInt(quantityEl?.innerHTML) - 1;
        } else if (operation === 'remove') {
            quantityEl.innerHTML = 0;
        }

        const quantity = parseInt(quantityEl?.innerHTML);

        const route = e.currentTarget.dataset.route;

        await this.processCartChanges(productId, quantity, route);
    }

    async processCartChanges(productId, quantity, route) {
        clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(async () => {
            const url = route + '?rest_language=' + this.currentLanguageCode;

            const data = new FormData();

            this.toggleLoading();
            this.clearErrors();

            data.append('productId', productId);
            data.append('quantity', quantity);

            let response;

            try {
                response = await axios.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } });

                response = response.data.data;

                if (response.removed) {
                    this.element.querySelector(`[data-product="${productId}"]`).remove();

                    if (!response.cart.hasOwnProperty('items')) {

                        if (response.general_error) {
                            alert(response.general_error);
                        }

                        window.location.reload();
                    }
                }

                if (response.cart) {
                    this.updateCartSummary(response.cart);
                }

                if (response.general_error) {
                    this.setupGeneralError(response.general_error)
                }

                if (response.quantity && response.product) {
                    this.setStock(response.quantity, response.product);
                }

                this.toggleLoading();

            } catch (error) {

                response = error.response.data.data;

                this.toggleLoading();
            }
        }, 500);
    }

    setStock(quantity, product) {
        document.querySelector('.eshop-summary ul li[data-product="' + product + '"] .product-quantity').innerHTML = quantity;
    }

    clearErrors() {
        const generalErrors = this.element.querySelectorAll('.general-error');
        generalErrors.forEach(error => error.remove());
    }

    setupGeneralError(error) {
        const messageNode = document.createElement('span');
        messageNode.classList.add('general-error');
        messageNode.innerHTML = error;

        const generalInfoHolder = this.element.querySelector('.general-info-holder');
        if (generalInfoHolder) {
            generalInfoHolder.appendChild(messageNode);
        } else {
            this.element.appendChild(messageNode);
        }

        this.element.classList.remove('loading');
    }

    updateCartSummary(cart) {
        const totalPrice = document.querySelector('#total-price');
        const oldPriceElement = totalPrice.querySelector('.oldPrice');
        const totalSumElement = totalPrice.querySelector('.total-sum');

        if (totalSumElement && oldPriceElement) {
            let oldPrice = 0;

            for (const item of cart.items) {
                if (item.hasOwnProperty('product_price_wo_disc')) {
                    oldPrice += item.product_price_wo_disc * item.product_quantity;
                }
            }

            oldPriceElement.innerHTML = `${Number(oldPrice.toFixed(2))}€ `;
            totalSumElement.innerHTML = ` = ${cart.total.total}€`;
        } else {
            if (cart.hasOwnProperty('total') && cart.total.hasOwnProperty('total') && cart.total.total) {
                oldPriceElement.innerHTML = `${cart.total.total}€`;
            }
        }
    }

    toggleLoading() {
        this.loading = !this.loading;

        this.element.querySelector('.summary').classList.toggle('loading', this.loading);
        document.querySelector('.total-price-holder').classList.toggle('loading', this.loading);
    }
}
